import React from "react";
import { Container, Box, Typography } from "@mui/material";
import ApplyNowForm from "./ApplyNowForm";

const ApplyNow = () => {
  const themeColors = {
    primary: "var(--primary-color)",
    lightBg: "#f8fbff",
  };

  return (
    <Box sx={{ bgcolor: themeColors.lightBg, minHeight: "100vh" }}>
      {/* Hero Section */}
      <Box sx={{ 
        bgcolor: themeColors.primary, 
        pt: { xs: 15, md: 20 }, 
        pb: { xs: 10, md: 15 },
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        mb: -10
      }}>
        <Box sx={{ 
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: "radial-gradient(circle at 80% 50%, rgba(255,255,255,0.05) 0%, transparent 50%)",
          zIndex: 0
        }} />
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <Typography variant="h2" sx={{ 
            color: '#fff', 
            fontWeight: 800, 
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            fontFamily: "'Roboto Slab', serif",
            mb: 2
          }}>
            Join Our Team
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.2rem', maxWidth: '700px', mx: 'auto' }}>
            Build your career with a firm that values innovation, integrity, and professional growth.
          </Typography>
        </Container>
      </Box>

      {/* Form Container */}
      <Container sx={{ position: 'relative', zIndex: 2, pb: 10 }}>
        <Box sx={{ maxWidth: '1000px', mx: 'auto' }}>
          <ApplyNowForm />
        </Box>
      </Container>
    </Box>
  );
};

export default ApplyNow;

